// src/services/actionPlans.ts
import { api } from "@/lib/apiClient";
import type {
  ActionPlan,
  ActionPlanAudit,
  ActionPlanCreateIn,
  ActionPlanExecutionAuditLog,
  ActionPlanExecutionAuditLogCreateIn,
  ActionPlanExecutionBoardItem,
  ActionPlanExecutionResponsibleOption,
  ActionPlanDetail,
  ActionPlanEvidence,
  ActionPlanEvidenceCreateIn,
  ActionPlanItem,
  ActionPlanItemCreateIn,
  ActionPlanItemStatusIn,
  ActionPlanItemUpdateIn,
  ActionPlanStatusIn,
  ActionPlanUpdateIn,
} from "@/types/actionPlans";

export async function listActionPlans(params?: {
  status?: string;
  risk_inventory_id?: string;
  risk_inventory_item_id?: string;
}) {
  return api.get<ActionPlan[]>("/action-plans", {
    params: {
      status: params?.status || undefined,
      risk_inventory_id: params?.risk_inventory_id || undefined,
      risk_inventory_item_id: params?.risk_inventory_item_id || undefined,
    },
  });
}

export async function getActionPlan(id: string) {
  return api.get<ActionPlanDetail>(`/action-plans/${id}`);
}

export async function createActionPlan(payload: ActionPlanCreateIn) {
  return api.post<ActionPlan>("/action-plans", payload);
}

export async function updateActionPlan(
  actionPlanId: string,
  payload: ActionPlanUpdateIn,
) {
  return api.put<ActionPlan>(`/action-plans/${actionPlanId}`, payload);
}

export async function setActionPlanStatus(
  actionPlanId: string,
  payload: ActionPlanStatusIn,
) {
  return api.patch<ActionPlan>(`/action-plans/${actionPlanId}/status`, payload);
}

export async function listActionPlanAuditLogs(actionPlanId: string) {
  return api.get<ActionPlanAudit[]>(`/action-plans/${actionPlanId}/audit-logs`);
}

export async function createActionPlanItem(
  actionPlanId: string,
  payload: ActionPlanItemCreateIn,
) {
  return api.post<ActionPlanItem>(`/action-plans/${actionPlanId}/items`, payload);
}

export async function updateActionPlanItem(
  itemId: string,
  payload: ActionPlanItemUpdateIn,
) {
  return api.put<ActionPlanItem>(`/action-plans/items/${itemId}`, payload);
}

export async function setActionPlanItemStatus(
  itemId: string,
  payload: ActionPlanItemStatusIn,
) {
  return api.patch<ActionPlanItem>(
    `/action-plans/items/${itemId}/status`,
    payload,
  );
}

export async function listActionPlanEvidences(itemId: string) {
  return api.get<ActionPlanEvidence[]>(`/action-plans/items/${itemId}/evidences`);
}

export async function createActionPlanEvidence(
  itemId: string,
  payload: ActionPlanEvidenceCreateIn,
) {
  return api.post<ActionPlanEvidence>(
    `/action-plans/items/${itemId}/evidences`,
    payload,
  );
}


export async function listActionPlanExecutionBoard(params?: {
  inventory_id?: string;
  inventory_item_id?: string;
  risk_catalog_id?: string;
  action_plan_id?: string;
  status?: string;
  priority?: string;
  responsible_user_id?: string;
  item_origin?: string;
  deadline_state?: string;
  q?: string;
}) {
  return api.get<ActionPlanExecutionBoardItem[]>("/action-plans/execution/board", { params });
}

export async function listActionPlanExecutionResponsibleUsers() {
  return api.get<ActionPlanExecutionResponsibleOption[]>("/action-plans/execution/responsible-users");
}


export async function listActionPlanExecutionItemAuditLogs(itemId: string) {
  return api.get<ActionPlanExecutionAuditLog[]>(`/action-plans/execution/items/${itemId}/audit-logs`);
}

export async function createActionPlanExecutionItemAuditLog(
  itemId: string,
  payload: ActionPlanExecutionAuditLogCreateIn,
) {
  return api.post<ActionPlanExecutionAuditLog>(`/action-plans/execution/items/${itemId}/audit-logs`, payload);
}
